import { render, staticRenderFns } from "./userstate.vue?vue&type=template&id=2d07da9f&scoped=true&"
import script from "./userstate.vue?vue&type=script&lang=js&"
export * from "./userstate.vue?vue&type=script&lang=js&"
import style0 from "./userstate.vue?vue&type=style&index=0&id=2d07da9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d07da9f",
  null
  
)

export default component.exports